import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CanActivateViaEmiTokenGuard } from 'app/emi-data.service';
import { CalculatorFormComponent } from './short-sweet/calculator-form/calculator-form.component';
import { BankComparisonSideMenuComponent } from 'app/calculators/home-loan-comparison-calculator/bank-comparison-side-menu/bank-comparison-side-menu.component';
import { CalculatorPageResolver } from 'app/service/calculator.resolve';
import { LeadResolver } from 'app/service/lead.resolve';


const loanRoutes: Routes = [
    {
        path: ':calculator-slug',
        component: BankComparisonSideMenuComponent,
        resolve: {
            productData: CalculatorPageResolver,
            lead: LeadResolver
        },
    }
    // {
    //     path: 'short-sweet',
    //     component: CalculatorFormComponent,
    // },
    // {
    //     path: 'savings',
    //     component: BankComparisonSideMenuComponent
    // },
];

@NgModule({
    imports: [
        RouterModule.forChild(loanRoutes)
    ],
    exports: [
        RouterModule
    ],
    providers: [CalculatorPageResolver, LeadResolver
    ]
})
export class CalculatorsRoutingModule {
}


// WEBPACK FOOTER //
// ./src/app/calculators/calculators-routing.module.ts